module.exports = __webpack_public_path__ + "img/3.38f11513.jpg";